import { SharedState } from '@/global.shared';

export const CxState = new SharedState();
